module.exports = __webpack_public_path__ + "img/services-shape-2.17c91da0.png";